module.exports = __webpack_public_path__ + "static/media/back_forgot.5f4e8f13.svg";